import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { RequestStatus } from "../../../model/ServiceRequestStatus.model"
import { generateOnePageSummary } from "../../../services/SPAAdmin/CampaignAgent.api";

export interface CampaignPageSummaryState {
    error: string | undefined,
    filePath: any | undefined,
    requestStatus: RequestStatus
}

const initialState: CampaignPageSummaryState = {
    error: undefined,
    filePath: undefined,
    requestStatus: RequestStatus.idle
}

export const CampaignPageSummarySlice = createSlice({
    name: 'CampaignPageSummary',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(generateOnePageSummary.pending, (state, _) => {
                state.requestStatus = RequestStatus.loading;
            })
            .addCase(generateOnePageSummary.fulfilled, (state, action: PayloadAction<any>) => {
                state.filePath = action;
                state.requestStatus = RequestStatus.succeeded;
            })
            .addCase(generateOnePageSummary.rejected, (state, action: any) => {
                state.error = "Get Campaign Page Summary: " + (action.payload['Message'] || action.error.message);
                state.requestStatus = RequestStatus.failed;
            })
    }
});

export const CampaignPageSummaryReducer = CampaignPageSummarySlice.reducer;